<div *ngIf="modo==='normal'">
  <!-- Hamburger Trigger -->
  <div (click)="abrirCerrar()" class="catego leftmargin noselect">
    <div class="imagmax">
      <i class="mdi mdi-menu icono-hamburguesa"></i>
    </div>
    <div *ngIf="width < 599 || width > 900" class="textecat">
      Categorías
    </div>
  </div>

  <!-- Sidebar Overlay -->
  <div class="sidebar-overlay" *ngIf="desplegado" [@overlayState]="desplegado ? 'open' : 'closed'"
    (click)="abrirCerrar()">
  </div>

  <!-- Side Drawer -->
  <div class="sidebar-drawer" [@sidebarState]="desplegado ? 'open' : 'closed'">

    <!-- Header minimo: solo cerrar -->
    <div class="sidebar-close-row" *ngIf="!enVistaPantallaEscritorio()">
      <button class="close-sidebar-btn" (click)="abrirCerrar()">
        <i class="mdi mdi-close"></i>
      </button>
    </div>

    <!-- Sidebar Content -->
    <div class="sidebar-content">

      <!-- Saludo: cuenta + seguir mis compras, arriba de todo -->
      <div class="sidebar-greeting" *ngIf="!enVistaPantallaEscritorio()">
        <div class="greeting-icon">
          <i class="mdi mdi-account-circle-outline"></i>
        </div>
        <div class="greeting-text" *ngIf="!user" (click)="openLogin()">
          <div class="greeting-title">¡Hola!</div>
          <div class="greeting-subtitle">Ingresá a tu cuenta</div>
        </div>
        <div class="greeting-text" *ngIf="user">
          <div class="greeting-title" (click)="gotoURL('/misdatos')">¡Hola, {{ user.nombre || user.username }}!</div>
          <div class="greeting-subtitle" (click)="gotoURL('/historial')">Ver mis compras</div>
        </div>
      </div>

      <div class="sidebar-divider" *ngIf="!enVistaPantallaEscritorio()"></div>

      <!-- Mi cuenta: arriba de todo cuando el usuario está logueado -->
      <div class="cuenta-section" *ngIf="!enVistaPantallaEscritorio() && user">
        <h3 class="sidebar-section-title">Mi cuenta</h3>
        <div class="nav-item-flat no-chevron" (click)="gotoURL('/misdatos')">
          <i class="mdi mdi-account-details-outline nav-icon-left"></i>
          <span class="nav-label">Mis Datos</span>
        </div>
        <div class="nav-item-flat no-chevron" (click)="gotoURL('/historial')">
          <i class="mdi mdi-clipboard-text-outline nav-icon-left"></i>
          <span class="nav-label">Mis Compras</span>
        </div>
        <div class="nav-item-flat no-chevron" *ngIf="mostrarMetodosPago" (click)="abrirMetodosPago()">
          <i class="mdi mdi-credit-card-outline nav-icon-left"></i>
          <span class="nav-label">Método de Pago</span>
        </div>
        <div class="nav-item-flat no-chevron" *ngIf="mostrarBeneficios" (click)="gotoURL('/beneficios')">
          <i class="mdi mdi-star-outline nav-icon-left"></i>
          <span class="nav-label">Beneficios</span>
        </div>
      </div>

      <div class="sidebar-divider" *ngIf="!enVistaPantallaEscritorio() && user"></div>

      <!-- Categories Section: primero, sin scroll ni bloques intermedios. Lista plana, se expande in-place para elegir subcategoría -->
      <div class="categories-mobile-section" *ngIf="!enVistaPantallaEscritorio()">
        <h3 class="sidebar-section-title">Categorías</h3>
        <div class="sidebar-categories-list-flat">
          <ng-container *ngFor="let catego of categorias">
            <div class="nav-item-flat" (click)="toggleCategoriaMobile(catego)">
              <span class="nav-label">{{ catego.nombre }}</span>
              <i class="mdi" [ngClass]="catego.desplegado ? 'mdi-chevron-down' : 'mdi-chevron-right'"></i>
            </div>
            <div class="subcategoria-flat-list" *ngIf="catego.desplegado">
              <ng-container *ngFor="let sub of catego.subCategorias">
                <div class="nav-item-flat sub" (click)="toggleSubCategoriaMobile(sub, catego)">
                  <span class="nav-label">{{ sub.nombre }}</span>
                  <i class="mdi" [ngClass]="sub.desplegado ? 'mdi-chevron-down' : 'mdi-chevron-right'"></i>
                </div>
                <div class="subcategoria-flat-list nivel3" *ngIf="sub.desplegado">
                  <div class="nav-item-flat sub2" *ngFor="let sub2 of sub.subCategorias"
                    (click)="irACategoria(sub2, catego)">
                    <span class="nav-label">{{ sub2.nombre }}</span>
                    <i class="mdi mdi-chevron-right"></i>
                  </div>
                </div>
              </ng-container>
            </div>
          </ng-container>
        </div>
      </div>

      <!-- Vista de escritorio: mantiene el acordeón con subcategorías -->
      <div class="categories-mobile-section" *ngIf="enVistaPantallaEscritorio()">
        <div class="sidebar-categories-list">
          <categ-viewgeneric *ngFor="let catego of categorias" [categoria]="catego" [mode]="modo"
            (categoriasEvento)="reiniciarFiltroCategoria($event)">
          </categ-viewgeneric>
        </div>
      </div>

      <div class="sidebar-divider" *ngIf="!enVistaPantallaEscritorio()"></div>

      <!-- Especiales: sección destacada arriba del resto del menú -->
      <div class="especiales-section" *ngIf="!enVistaPantallaEscritorio() && menuOfertas">
        <h3 class="sidebar-section-title">Especiales</h3>
        <div class="nav-item-flat no-chevron" (click)="menuclick(menuOfertas)">
          <i class="mdi mdi-leaf nav-icon-left"></i>
          <span class="nav-label">{{ menuOfertas.nombre }}</span>
        </div>
      </div>

      <div class="sidebar-divider" *ngIf="!enVistaPantallaEscritorio() && menuOfertas"></div>

      <!-- Main Navigation: un solo patrón (texto + flecha), sin 'Productos' (ya cubierto por categorías) -->
      <nav class="main-nav-mobile" *ngIf="!enVistaPantallaEscritorio()">
        <ng-container *ngFor="let menu of menus">
          <div *ngIf="!menu.oculto && menu.ruta !== 'busqueda' && menu.ruta !== 'historial' && menu.ruta !== 'ofertas' && (menu.ruta !== 'marcas' || hayMarcas)"
            (click)="menuclick(menu)" class="nav-item-mobile">
            <i class="mdi mdi-chevron-right nav-icon"></i>
            <span class="nav-label">{{ menu.nombre }}</span>
          </div>
        </ng-container>

        <div class="nav-item-mobile logout-item" *ngIf="user" (click)="cerrarSesion()">
          <i class="mdi mdi-logout nav-icon"></i>
          <span class="nav-label">Cerrar Sesión</span>
        </div>
      </nav>

      <div class="sidebar-divider" *ngIf="!enVistaPantallaEscritorio()"></div>

      <!-- Institucional: agrupado al final, tenue, separado del flujo de compra -->
      <nav class="institutional-nav-mobile" *ngIf="!enVistaPantallaEscritorio()">
        <div class="nav-item-mobile institutional" (click)="abrirInstitucional('modal-data-empresa')">
          <span class="nav-label">Nuestra Empresa</span>
        </div>
        <div class="nav-item-mobile institutional" (click)="abrirInstitucional('modal-work-withAs')">
          <span class="nav-label">Trabajá con nosotros</span>
        </div>
        <div class="nav-item-mobile institutional" (click)="abrirInstitucional('modal-info-prov')">
          <span class="nav-label">Proveedores</span>
        </div>
        <div class="nav-item-mobile institutional" (click)="abrirInstitucional('modal-terminos-condiciones')">
          <span class="nav-label">Términos y Condiciones</span>
        </div>
      </nav>
    </div>
  </div>

</div>
